<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />
    <a-col v-else class="height100 flex-1">
      <a-tabs :key="$route.fullPath" class="main-tabs" type="card">
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>

          <!-- lang tabs -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
              </a-row>
            </a-col>
          </a-row>

          <!-- avatar -->
          <a-row align="middle" class="input-form__group">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 4px; padding-right: 8px"
            >
              Фото:
            </a-col>
            <a-col :span="12">
              <a-row align="top" type="flex">
                <a-avatar
                  :size="86"
                  :src="ccAvatar"
                  icon="user"
                  shape="square"
                />

                <input
                  ref="avatarInputRef"
                  accept="image/jpeg, image/png"
                  hidden
                  type="file"
                  @change="handleAvatar"
                />
                <a-button class="ml-1x" @click="showModal(true)">
                  Выбрать
                </a-button>

                <a-button class="ml-1x" @click="removeAvatar">
                  Удалить
                </a-button>
              </a-row>
              <!--              <div class="error-text" v-if="!$v.avatar.required">-->
              <!--                Выберите изображение.-->
              <!--              </div>-->
            </a-col>
          </a-row>

          <!-- full name -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Название подразделения:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model.trim="form.full_name[langTab]"
                placeholder="Введите название подразделения"
              />
            </a-col>
          </a-row>

          <!-- Звание начальника -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Адрес
            </a-col>
            <a-col :span="12">
              <a-input
                v-model.trim="form.leader_position[langTab]"
                placeholder="Введите адрес"
              />
            </a-col>
          </a-row>

          <!-- department_name -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Подзаголовок
            </a-col>
            <a-col :span="12">
              <a-input
                v-model.trim="form.department_name[langTab]"
                placeholder="Название депратамента"
              />
            </a-col>
          </a-row>

          <!-- phone -->
          <a-row align="top" class="input-form__group" type="flex">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 5px; padding-right: 8px"
            >
              Номер телефона:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model="form.phone"
                style="width: 100%"
                placeholder="+998 (XX) XXX-XX-XX"
              />
            </a-col>
          </a-row>

          <!-- lat -->
          <a-row align="top" class="input-form__group" type="flex">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 5px; padding-right: 8px"
            >
              Широта (для указания на карте)
            </a-col>
            <a-col :span="12">
              <a-input-number
                v-model="form.lat"
                style="width: 100%"
                placeholder
                :step="0.00001"
              />
            </a-col>
          </a-row>

          <!-- lng -->
          <a-row align="top" class="input-form__group" type="flex">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 5px; padding-right: 8px"
            >
              Долгота (для указания на карте)
            </a-col>
            <a-col :span="12">
              <a-input-number
                v-model="form.lng"
                style="width: 100%"
                placeholder
                :step="0.00001"
              />
            </a-col>
          </a-row>

          <!-- work days -->
          <a-row align="top" class="input-form__group" type="flex">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 5px; padding-right: 8px"
            >
              Дни приема:
            </a-col>
            <a-col :span="12">
              <a-textarea
                v-model="form.work_days[langTab]"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="Введите дни приема"
              />
            </a-col>
          </a-row>

          <!-- autobiography -->
          <!-- <a-row align="top" class="input-form__group" type="flex">
                        <a-col
                            :span="6"
                            style="text-align: right; padding-top: 5px; padding-right: 8px;"
                        >Автобиография:</a-col>
                        <a-col :span="12">
                            <a-textarea
                                :autosize="{ minRows: 2, maxRows: 6 }"
                                placeholder="Введите автобиографию"
                                v-model="form.autobiography[langTab]"
                            />
                        </a-col>
                    </a-row> -->

          <!-- commitment -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Обязательство:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model="form.commitment[langTab]"
                placeholder="Введите обязательство"
              />
            </a-col>
          </a-row>
          <!-- rahbar -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Rahbariyat:
            </a-col>
            <a-col :span="12">
              <a-select
                v-model="leaders"
                label-in-value
                mode="multiple"
                style="width: 100%"
                placeholder="Please select leader"
              >
                <a-select-option
                  v-for="leader in leadersForOptions"
                  :key="leader.id"
                >
                  {{ leader.id }} {{ leader.full_name }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>

          <!-- editor -->
          <a-row align="middle" class="input-form__group">
            <a-col> Прочее: </a-col>
            <a-col>
              <editor
                :key="'tinymce_' + langTab"
                v-model="form.additional_data[langTab]"
                :init="{
                  height: 450,
                  plugins: [
                    'advlist autolink lists link image imagetools charmap print preview',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                  ],
                  fontsize_formats:
                    '8px 10px 12px 14px 16px 18px 24px 36px 40px 72px',
                  toolbar:
                    'undo redo | formatselect fontsizeselect | bold italic underline forecolor | \
                                    image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                                    bullist numlist outdent indent | removeformat',
                  language: 'ru',
                  language_url: '/js/tinymce/langs/ru.js',
                  menubar: false,
                  images_upload_url: false,
                  automatic_uploads: false,
                  relative_urls: false,
                  images_reuse_filename: true,
                  images_dataimg_filter: function (img) {
                    return img.hasAttribute('internal-blob')
                  }
                }"
                api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
              />
            </a-col>
          </a-row>

          <!-- position -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Позиция:
            </a-col>
            <a-col :span="12">
              <a-input-number
                v-model.number="form.position"
                style="width: 100%"
                placeholder="Введите позицию"
              />
            </a-col>
          </a-row>

          <!-- status toggle -->
          <a-row class="input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Статус:
            </a-col>
            <a-switch v-model="form.status" />
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
    <osg-cropper
      v-if="showForm"
      v-model="showForm"
      :ratio-width="19"
      :ratio-height="23"
      :quality="0.9"
      @onImageSelected="setImageExtention"
      @onSetImage="getImage"
    />
  </a-row>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"

import { mapActions, mapGetters } from "vuex"

const fields = {
  full_name: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  department_name: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  position: 1,
  phone: "",
  lat: 41.304656,
  lng: 69.264127,
  work_days: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  autobiography: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  commitment: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  leader_position: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  leaders: [],
  leadership: [],

  status: true,
  avatar: null,
  additional_data: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  }
}

export default {
  components: {
    "osg-cropper": () => import("@/components/imageCrop/modalCrop"),
    editor: Editor
  },
  data: () => ({
    leaders: [],
    fileExtension: "jpeg",
    showForm: false,
    form: { ...fields },
    loading: false,
    pending: false,
    // eslint-disable-next-line no-undef
    langTab: $langPrefix,
    avatar: null,
    leader_position: null
  }),

  computed: {
    ...mapGetters("leadership", { leadersForOptions: "sortedList" }),
    cAvatar: {
      get() {
        if (this.avatar) {
          return URL.createObjectURL(this.avatar)
        }

        if (this.form.avatar) {
          return this.filesUrl + this.form.avatar
        }

        return require("@/assets/img/no-photo-1.png")
      }
    },
    ccAvatar: {
      get() {
        if (this.avatar) {
          return URL.createObjectURL(this.avatar)
        }

        if (this.form.avatar) {
          return this.filesUrl + this.form.avatar
        }

        return ""
      }
    },

    isContentNull() {
      return !!(
        // Object.keys(this.form.content).find(key => this.form.content[key])
        (
          !this.form.content.uz &&
          !this.form.content.oz &&
          !this.form.content.ru &&
          !this.form.content.en
        )
      )
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },

  beforeDestroy() {
    this.$set(this, "form", {
      ...fields
    })
  },
  mounted() {
    if (this.leadersForOptions.length === 0) {
      this.$store.dispatch("leadership/fetch")
    }
  },

  methods: {
    ...mapActions("department", ["detail"]),
    setImageExtention(e) {
      this.fileExtension = e
    },
    showModal(value) {
      this.showForm = value
    },
    handleAvatar(e) {
      if (e.target.files && e.target.files[0]) {
        this.avatar = e.target.files[0]
      }

      this.$refs.avatarInputRef.value = null
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },
    getImage(variable) {
      this.urltoFile(
        variable,
        this.fileExtension,
        `image/${this.fileExtension}`
      ).then((file) => {
        this.avatar = file
      })
    },
    toBlob(file) {
      if (file) {
        return URL.createObjectURL(file)
      }
    },
    removeAvatar() {
      this.avatar = null
      this.form.avatar = null
    },
    async fetchData() {
      this.loading = true

      this.$set(this, "form", {
        ...fields
      })

      try {
        if (this.$route.params.id) {
          const res = await this.detail(this.$route.params.id)
          if (res) {
            this.leaders = res.leadership.map((l) => ({
              key: l.id,
              label: l.full_name
            }))
            this.$set(this, "form", {
              ...res,
              autobiography: (res.autobiography &&
                JSON.parse(res.autobiography)) || {
                ...this.langKeys
              },
              full_name: (res.full_name && JSON.parse(res.full_name)) || {
                ...this.langKeys
              },
              work_days: (res.work_days && JSON.parse(res.work_days)) || {
                ...this.langKeys
              },
              commitment: (res.commitment && JSON.parse(res.commitment)) || {
                ...this.langKeys
              },
              department_name: (res.department_name &&
                JSON.parse(res.department_name)) || {
                ...this.langKeys
              },
              leader_position: (res.leader_position &&
                JSON.parse(res.leader_position)) || {
                ...this.langKeys
              },
              additional_data: (res.additional_data &&
                JSON.parse(res.additional_data)) || {
                ...this.langKeys
              }
            })
          }
        }
      } catch (e) {
        console.log(e)
        this.loading = false
      }

      this.loading = false
    },
    async submit() {
      // do your submit logic here
      this.pending = true
      let prohibited = ["leadership", "leaders", "avatar"]
      const f = new FormData()
      this.leaders.forEach((l) => {
        f.append("leaders", l.key)
      })
      Object.keys(this.form).forEach((key) => {
        if (this.form[key] && !prohibited.includes(key)) {
          if (!isNaN(this.form[key])) {
            f.append(key, this.form[key])
          } else {
            if (key === "phone" || key === "lat" || key === "lng") {
              // if(this.form[key] !== null){
              f.append(key, this.form[key])
              //
            } else {
              f.append(key, JSON.stringify(this.form[key]))
            }
          }
        }
      })
      if (this.avatar) {
        console.log(1111111)
        f.append("avatar", this.avatar)
        // f.append("avatar", this.avatar);
      } else if (!this.form.avatar && this.form.id) {
        this.DeleteAvatar()
        console.log(22222)
      } else {
        console.log(33333)
        f.append("avatar", JSON.stringify(this.form["avatar"]))
      }
      for (var value of f.values()) {
        console.log("typeof", typeof value)
      }

      try {
        const res = await this.$store.dispatch(
          `department/${this.form.id ? "update" : "create"}ItemAction`,
          {
            id: this.form.id || null,
            data: f
          }
        )

        if (res && res.data && res.data.id) {
          this.$message.success("Успешно сохранено")
          this.$router.go(-1)
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }

      this.pending = false
    },
    async DeleteAvatar() {
      try {
        const res = await this.$store.dispatch(
          `department/DeleteAvatar`,
          this.form.id
        )

        if (res) {
          this.$message.success("Успешно удалено")
          this.pending = false
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }
    }
  }
}
</script>
